import { Box, Typography } from '@mui/material';
import TypeText from '../../../form/form-fields/TypeText';
import { useTranslation } from 'react-i18next';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import TypeCheckbox from '../../../form/form-fields/TypeCheckbox';

export const MatchingPropFieldCheckbox = ({ property, onChange }) => {
  const { t } = useTranslation();

  const publicLabelField = {
    label: property.label,
    key: 'publicLabel',
  };
  const valueField = {
    label: '',
    key: 'value',
    unit: property.unit,
  };

  function handleUpdate(key, value) {
    const newProp = { ...property, [key]: value };
    onChange(newProp);
  }

  return (
    <Box className="flex items-center gap-1 w-full">
      <Box className="w-full">
        <TypeText
          size="small"
          field={publicLabelField}
          dataCollection={property}
          updateValidationOnChange={handleUpdate}
        />
      </Box>
      <KeyboardArrowRightIcon />
      <Box className="w-full">
        <TypeCheckbox
          size="small"
          field={valueField}
          dataCollection={property}
          updateValidationOnChange={handleUpdate}
        />
      </Box>
    </Box>
  );
};
